/**
 * The tabs of the course settings page (13.10.2026). The page had grown to
 * fifteen cards one under another; they are the same cards, grouped by what
 * belongs together. The tab is kept in the address (`?sectiune=plati`), so a
 * link opens on it and a reload stays on it.
 */
export const SETTINGS_TAB_PARAM = "sectiune";

export const SETTINGS_TABS = [
  { key: "inscriere", label: "Înscriere și preț" },
  { key: "plati", label: "Plăți și facturi" },
  { key: "contracte", label: "Contracte" },
  { key: "logiscool", label: "Logiscool" },
  { key: "site", label: "Site și leaduri" },
  { key: "recomandari", label: "Recomandări" },
  { key: "evaluare", label: "Evaluare inițială" },
  { key: "feedback", label: "Feedback de final" },
  { key: "emailuri", label: "Emailuri" },
];

/** The tab an address asks for, or the first one for anything unknown. */
export function settingsTabOf(value) {
  return SETTINGS_TABS.some((t) => t.key === value) ? value : SETTINGS_TABS[0].key;
}

const ONLINE_MODES = ["online_payment", "online_payment_no_group"];

/** A checkout that takes payment while online payments are not ready. */
export function onlinePaymentBlocked(data) {
  return ONLINE_MODES.includes(data?.checkout_mode) && !data?.online_payment_ready;
}

/**
 * What needs attention, per tab: `{ plati: ["…"] }`. A warning shown inside a
 * card is invisible while another tab is open, so the tab that holds the fix
 * carries a dot. Only what the settings payload itself says; the cards that
 * load their own state (contracts, Logiscool, emails) show it when opened.
 */
export function settingsAttention(data) {
  const out = {};
  const add = (tab, message) => { out[tab] = [...(out[tab] || []), message]; };
  if (onlinePaymentBlocked(data)) {
    add("plati", "Checkout-ul cere plată online, dar plățile online nu sunt active.");
  }
  const smartbill = data?.smartbill_diagnostics || {};
  const started = Boolean(smartbill.username_masked || smartbill.token_configured || smartbill.cif || smartbill.series);
  if (started && !data?.smartbill_configured) {
    add("plati", (smartbill.missing_required_fields || []).length > 0
      ? "SmartBill e configurat incomplet."
      : "Facturarea SmartBill e oprită.");
  }
  return out;
}
